// Side Menu has: 1- Logo (clicable) 2-tabs (icone - title) 3- toggle (half close)
import React, { Component } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Collapse,
  Button,
  Container,
} from "reactstrap";
import "./SideMenu.css";
import { EventSideNavs, EventSideNavsEn } from "./EventRoute_SideMenu";
import { CinemaSideNavs, CinemaSideNavsEn } from "./CinemaRoute_SideMenu";
import { Link } from "react-router-dom";
import logo from "../../../Assets/Images/logoWihte.png";
import cookie from "react-cookies";
import { API_ENDPOINT } from "../../../AppConfig";
import axios from "axios";
import { connect } from "react-redux";

const badgeColor = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "light",
];
let badgeColorIndex = 0;

let CurrentUser = null;
class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      direction: false, //ar
      flag: true,
      toggle: false,
      collapsemenu: false,
      textItem: "",
      smallScreen: false,
      scrolFlag: false,
      tooltipOpen_Mail: false,
      SidemnuBG: localStorage.getItem("SidemnuBG"),
      availtableTabs: [],
      newClientsSocket: 0,
      newDriverSocket: 0,
      // newTripsSocket:0,
      SideNavs:[],
      SideNavsEn:[],
    };

    this.toggle = this.toggle.bind(this);
    this.togglemenu = this.togglemenu.bind(this);
    this.setTextitem = this.setTextitem.bind(this);
    this.toolTiptoggle_Mail = this.toolTiptoggle_Mail.bind(this);
  }
  togglemenu() {
    this.setState((state) => ({ collapsemenu: !state.collapsemenu }));
  }

  getbadgeColor() {
    if (badgeColorIndex === badgeColor.length) {
      badgeColorIndex = 0;
    }
    return badgeColor[badgeColorIndex++];
  }
  toolTiptoggle_Mail() {
    this.setState({
      tooltipOpen_Mail: !this.state.tooltipOpen_Mail,
    });
  }
  setTextitem(text) {
    this.setState({ textItem: text }, () => {});
  }
  toggle() {
    this.setState((state) => ({ toggle: !state.toggle }));
  }
  handelToggleSideMenu = () => {
    if (window.innerWidth < 766) {
      this.setState(
        { flag: !this.state.flag, smallScreen: !this.state.smallScreen },
        () => {
          this.props.handeltoggle(this.state.flag);
        }
      );
    } else {
      this.setState({ flag: !this.state.flag }, () => {
        this.props.handeltoggle(this.state.flag);
      });
    }
  };

  UNSAFE_componentWillMount() {
    // this.setState({ SidemnuBG: localStorage.getItem('SidemnuBG') })
    if (this.props.user && this.props.user.categoryType === "EVENTS") {
      this.setState({ SideNavs: EventSideNavs, SideNavsEn: EventSideNavsEn });
    } else {
      this.setState(
        { SideNavs: CinemaSideNavs, SideNavsEn: CinemaSideNavsEn },
        () => {
          console.log("Side nav State:", this.state.SideNavs);
        }
      );
    }

    if (window.innerWidth < 766) {
      this.setState({ smallScreen: true, flag: false });
    }
    let UserType = sessionStorage.getItem("TicketUser");
     if (UserType === "CINEMA") {
      CurrentUser = cookie.load("My-Ticketuser-cinema");
    } else {
      CurrentUser = cookie.load("My-Ticketuser-event");
    }
    console.log("Current user:", CurrentUser);
    this.getAllRoles();
  }

  getAllRoles() {
    console.log("current user---> ", CurrentUser);
    if (CurrentUser&&CurrentUser.type === "SUB_ADMIN") {
      let availtableTabsTemp = [];
      for (let i = 0; i < CurrentUser.rules.length; i++) {
        let uri = `${API_ENDPOINT}/assigRule/${CurrentUser.rules[i].id}`;
        console.log("getAllRoles req uri==> ", uri);
        axios
          .get(uri, {
            headers: {
              Authorization: `Bearer ${this.props.token}`,
            },
          })
          .then((response) => {
            console.log("getAllRoles req done=> ", response.data);
            availtableTabsTemp.push(response.data.rule.number);
            this.setState({
              availtableTabs: availtableTabsTemp,
            });
          })
          .catch((error) => {
            console.log("getAllRoles req failed==> ", error.response);
          });
      }
    }
  }

  componentDidMount() {}

  handelenterMouse = () => {
    this.setState({ scrolFlag: true });
  };
  handelleaveMouse = () => {
    this.setState({ scrolFlag: false });
  };

  IsArrayHasRole(ChildArray) {
    for (let j = 0; j < this.state.availtableTabs.length; j++) {
      for (let i = 0; i < ChildArray.length; i++) {
        if (
          this.state.availtableTabs[j] === ChildArray[i].roleNumber ||
          ChildArray[i].roleNumber === -1
        ) {
          return true;
        }
      }
    }
    return false;
  }
  getroleNumber(number) {
    console.log("this.state.availtableTabs===> ", this.state.availtableTabs);
    if (number === -1) {
      return true;
    }
    for (let i = 0; i < this.state.availtableTabs.length; i++) {
      if (this.state.availtableTabs[i] === number || number === -1) {
        return true;
      }
    }
    return false;
  }

  render() {
    badgeColorIndex = 0;
    let layoutSide = this.props.sideMenu;
    var color = this.state.SidemnuBG
      ? this.state.SidemnuBG.includes("#")
      : false;
    if (layoutSide && layoutSide !== this.state.SidemnuBG) {
      this.setState({ SidemnuBG: layoutSide });
      color = layoutSide.includes("#");
    }

    let direction = this.props.direction;
    console.log("CurrentUser", CurrentUser);
    return (
      <div
        className={
          !direction
            ? this.state.smallScreen && this.state.flag
              ? "sidemenueclose"
              : !this.state.flag
              ? "sidemenueclose side-en sideMenu"
              : "sidemenueopen side-en sideMenu"
            : this.state.smallScreen && this.state.flag
            ? "sidemenueclose"
            : !this.state.flag
            ? "sidemenueclose side-ar sideMenu"
            : "sidemenueopen side-ar sideMenu"
        }
      >
        <Button
          id="toggleSideMenuBtn"
          onClick={this.handelToggleSideMenu}
          className={
            !direction
              ? this.state.smallScreen && this.state.flag
                ? "sidecloseenBTN"
                : !this.state.flag
                ? "sidecloseenBTN"
                : "sideopenenBTN"
              : this.state.smallScreen && this.state.flag
              ? "sideclosearBTN"
              : !this.state.flag
              ? "sideclosearBTN"
              : "sideopenarBTN"
          }
        >
          <i className="fas fa-bars"></i>
        </Button>

        {/* } */}

        <div
          className={`${this.state.SidemnuBG} sideMenuContentStyle`}
          onMouseEnter={this.handelenterMouse}
          onMouseLeave={this.handelleaveMouse}
        >
          <div
            className="sideMenuContentStyleOvelay"
            style={{
              backgroundColor: color
                ? this.state.SidemnuBG
                  ? this.state.SidemnuBG
                  : "#1E1E1E"
                : "",
            }}
          >
            <Container>
              <Row style={{ textAlign: direction ? "right" : "left" }}>
                <Col lg="12" md="12" className="p-0 m-0 mb-3 d-flex">
                  <Link
                    to={ this.props.user.categoryType === "CINEMA"
                        ? "/MyticketCinema/Cinema-dashboard"
                        : "/MyticketCinema/EventDashboard"
                    }
                    className="text-center"
                    style={{margin:'0 auto'}}
                  >
                    <img
                      src={logo}
                      style={{
                        width: "75%",
                        transition: "all 0.6s ease",
                        margin: "30px 0px 0",
                        paddingBottom: "30px",
                      }}
                      alt="Logo"
                    />
                  </Link>
                </Col>
                <Col
                  lg="12"
                  md="12"
                  className={this.state.flag ? "m-0 mb-2 " : "m-0 mb-2 "}
                >
                  <Row className={"sideMenu-scroll"}>
                    {direction
                      ? this.state.SideNavs.items.map((text, index) => {
                          return this.props.token ? (
                            CurrentUser.type === "ADMIN" ||
                            CurrentUser.type === "OTHER" ? (
                              text.childrens ? (
                                <Col
                                  lg="12"
                                  className="headerBorder headerBorderar p-2"
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.textItem === text &&
                                      this.state.toggle
                                        ? "rgba(30, 30, 30,.6)"
                                        : "",
                                    display: "block",
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "6px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  <h5
                                    id={this.state.flag ? "" : "centerIcons"}
                                    onClick={() => {
                                      this.toggle();
                                      this.togglemenu();
                                      this.setTextitem(text);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <Row> */}
                                    <div lg="9" md="9" sm="11" xs="11">
                                      <i
                                        style={{
                                          color: "#fffe",
                                          paddingLeft: "4px",
                                          display:
                                            this.state.smallScreen &&
                                            !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        className={text.icon}
                                      ></i>
                                      <span
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                          fontSize: "14px",
                                          color: "#ffffffcc",
                                        }}
                                      >
                                        {text.name}
                                      </span>
                                    </div>
                                    <div
                                      className="fixWidthIcon px-0"
                                      lg="2"
                                      md="2"
                                      sm="1"
                                      xs="1"
                                    >
                                      <i
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                        }}
                                        className={
                                          this.state.textItem === text &&
                                          this.state.toggle
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                        }
                                      ></i>
                                    </div>
                                    {/* </Row> */}
                                  </h5>
                                  <Collapse
                                    isOpen={
                                      this.state.collapsemenu &&
                                      text === this.state.textItem
                                    }
                                  >
                                    <Card>
                                      <CardBody>
                                        <ul
                                          className={
                                            direction ? "mr-4" : "ml-4"
                                          }
                                        >
                                          {text.childrens.map((child, ind) => (
                                            <li>
                                              <Link
                                                style={{ color: "#fff" }}
                                                to={{
                                                  pathname: child.url,
                                                  state: child.state,
                                                }}
                                              >
                                                {" "}
                                                {child.name}{" "}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      </CardBody>
                                    </Card>
                                  </Collapse>
                                </Col>
                              ) : (
                                <Col
                                  lg="12"
                                  className="p-2"
                                  style={{
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "6px",
                                    paddingLeft: "6px",
                                  }}
                                >
                                  <Link
                                    id={this.state.flag ? "" : "centerIcons"}
                                    to={{ pathname: text.url }}
                                  >
                                    <i
                                      style={{
                                        color: "#fffffe",
                                        paddingLeft: "4px",
                                        display:
                                          this.state.smallScreen &&
                                          !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                      }}
                                      className={text.icon}
                                    ></i>

                                    <span
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                        fontSize: "14px",
                                        color: "#ffffffcc",
                                      }}
                                      onClick={() => {
                                        this.setState(
                                          { collapsemenu: false },
                                          () => {
                                            this.setTextitem(text);
                                          }
                                        );
                                      }}
                                    >
                                      {text.name}
                                    </span>
                                  </Link>
                                </Col>
                              )
                            ) : text.childrens ? (
                              text.roleNumber ? (
                                this.getroleNumber(text.roleNumber) && (
                                  <Col
                                    lg="12"
                                    className="headerBorder headerBorderen pb-2"
                                    key={index}
                                    style={{
                                      backgroundColor:
                                        this.state.textItem === text &&
                                        this.state.toggle
                                          ? "rgba(30, 30, 30,.6)"
                                          : "",
                                      display: "block",
                                      marginBottom: this.state.flag
                                        ? ""
                                        : "1.5rem",
                                      paddingRight: "15px",
                                      paddingLeft: "6px",
                                    }}
                                  >
                                    <h5
                                      id={this.state.flag ? "" : "centerIcons"}
                                      onClick={() => {
                                        this.toggle();
                                        this.togglemenu();
                                        this.setTextitem(text);
                                      }}
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {/* <Row> */}
                                      <div lg="9" md="9" sm="11" xs="11">
                                        <i
                                          style={{
                                            color: "#fffe",
                                            paddingRight: "4px",
                                            display:
                                              this.state.smallScreen &&
                                              !this.state.flag
                                                ? "none"
                                                : "inline-block",
                                          }}
                                          className={text.icon}
                                        ></i>
                                        <span
                                          style={{
                                            display: !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                            fontSize: "14px",
                                            color: "#ffffffcc",
                                          }}
                                        >
                                          {text.name}
                                        </span>
                                      </div>
                                      <div
                                        className="fixWidthIcon"
                                        lg="2"
                                        md="2"
                                        sm="1"
                                        xs="1"
                                      >
                                        <i
                                          style={{
                                            display: !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                          }}
                                          className={
                                            this.state.textItem === text &&
                                            this.state.toggle
                                              ? "fa fa-chevron-up"
                                              : "fa fa-chevron-down"
                                          }
                                        ></i>
                                      </div>
                                      {/* </Row> */}
                                    </h5>
                                    <Collapse
                                      isOpen={
                                        this.state.collapsemenu &&
                                        text === this.state.textItem
                                      }
                                    >
                                      <Card>
                                        <CardBody>
                                          <ul
                                            className={
                                              direction ? "mr-4" : "ml-4"
                                            }
                                          >
                                            {text.childrens.map((child, ind) =>
                                              this.getroleNumber(
                                                child.roleNumber
                                              ) ? (
                                                <li>
                                                  <Link
                                                    style={{ color: "#fff" }}
                                                    to={{
                                                      pathname: child.url,
                                                      state: child.state,
                                                    }}
                                                  >
                                                    {" "}
                                                    {child.name}{" "}
                                                  </Link>
                                                </li>
                                              ) : null
                                            )}
                                          </ul>
                                        </CardBody>
                                      </Card>
                                    </Collapse>
                                  </Col>
                                )
                              ) : this.IsArrayHasRole(text.childrens) ? (
                                <Col
                                  lg="12"
                                  className="headerBorder headerBorderar pb-2"
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.textItem === text &&
                                      this.state.toggle
                                        ? "rgba(30, 30, 30,.6)"
                                        : "",
                                    display: "block",
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "6px",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  <h5
                                    id={this.state.flag ? "" : "centerIcons"}
                                    onClick={() => {
                                      this.toggle();
                                      this.togglemenu();
                                      this.setTextitem(text);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <Row> */}
                                    <div lg="9" md="9" sm="11" xs="11">
                                      <i
                                        style={{
                                          color: "#fffe",
                                          paddingLeft: "4px",
                                          display:
                                            this.state.smallScreen &&
                                            !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        className={text.icon}
                                      ></i>
                                      <span
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                          fontSize: "14px",
                                          color: "#ffffffcc",
                                        }}
                                      >
                                        {text.name}
                                      </span>
                                    </div>
                                    <div
                                      className="fixWidthIcon px-0"
                                      lg="2"
                                      md="2"
                                      sm="1"
                                      xs="1"
                                    >
                                      <i
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                        }}
                                        className={
                                          this.state.textItem === text &&
                                          this.state.toggle
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                        }
                                      ></i>
                                    </div>
                                    {/* </Row> */}
                                  </h5>
                                  <Collapse
                                    isOpen={
                                      this.state.collapsemenu &&
                                      text === this.state.textItem
                                    }
                                  >
                                    <Card>
                                      <CardBody>
                                        <ul
                                          className={
                                            direction ? "mr-4" : "ml-4"
                                          }
                                        >
                                          {text.childrens.map(
                                            (child, ind) =>
                                              this.getroleNumber(
                                                child.roleNumber
                                              ) && (
                                                <li>
                                                  <Link
                                                    style={{ color: "#fff" }}
                                                    to={{
                                                      pathname: child.url,
                                                      state: child.state,
                                                    }}
                                                  >
                                                    {" "}
                                                    {child.name}{" "}
                                                  </Link>
                                                </li>
                                              )
                                          )}
                                        </ul>
                                      </CardBody>
                                    </Card>
                                  </Collapse>
                                </Col>
                              ) : null
                            ) : (
                              <Col
                                lg="12"
                                className="pb-2"
                                style={{
                                  display: this.getroleNumber(text.roleNumber)
                                    ? ""
                                    : "none",
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "6px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <Link
                                  id={this.state.flag ? "" : "centerIcons"}
                                  to={{ pathname: text.url }}
                                >
                                  <i
                                    style={{
                                      color: "#fffffe",
                                      paddingLeft: "4px",
                                      display:
                                        this.state.smallScreen &&
                                        !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                    }}
                                    className={text.icon}
                                  ></i>

                                  <span
                                    style={{
                                      display: !this.state.flag
                                        ? "none"
                                        : "inline-block",
                                      fontSize: "14px",
                                      color: "#ffffffcc",
                                    }}
                                    onClick={() => {
                                      this.setState(
                                        { collapsemenu: false },
                                        () => {
                                          this.setTextitem(text);
                                        }
                                      );
                                    }}
                                  >
                                    {text.name}
                                  </span>
                                  {/* {text.badge === true && text.badgeData.length > 0 ?
                                                                text.badgeData.map((ele, index) => {
                                                                    return (
                                                                        <span>
                                                                            <Badge id={text.target} className="mx-1 p-1" style={{ fontSize: '13px!important' }} color={this.getbadgeColor()}>{ele}</Badge>
                                                                        </span>
                                                                    )
                                                                })
    
                                                                : null} */}
                                </Link>
                              </Col>
                            )
                          ) : null;
                        })
                      : this.state.SideNavsEn.items.map((text, index) => {
                          return CurrentUser.type === "ADMIN" ||
                            CurrentUser.type === "OTHER" ? (
                            text.childrens ? (
                              <Col
                                lg="12"
                                className="headerBorder headerBorderen pb-2"
                                key={index}
                                style={{
                                  backgroundColor:
                                    this.state.textItem === text &&
                                    this.state.toggle
                                      ? "rgba(30, 30, 30,.6)"
                                      : "",
                                  display: "block",
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "15px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <h5
                                  id={this.state.flag ? "" : "centerIcons"}
                                  onClick={() => {
                                    this.toggle();
                                    this.togglemenu();
                                    this.setTextitem(text);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {/* <Row> */}
                                  <div lg="9" md="9" sm="11" xs="11">
                                    <i
                                      style={{
                                        color: "#fffe",
                                        paddingRight: "4px",
                                        display:
                                          this.state.smallScreen &&
                                          !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                      }}
                                      className={text.icon}
                                    ></i>
                                    <span
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                        fontSize: "14px",
                                        color: "#ffffffcc",
                                      }}
                                    >
                                      {text.name}
                                    </span>
                                  </div>
                                  <div
                                    className="fixWidthIcon"
                                    lg="2"
                                    md="2"
                                    sm="1"
                                    xs="1"
                                  >
                                    <i
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                      }}
                                      className={
                                        this.state.textItem === text &&
                                        this.state.toggle
                                          ? "fa fa-chevron-up"
                                          : "fa fa-chevron-down"
                                      }
                                    ></i>
                                  </div>
                                  {/* </Row> */}
                                </h5>
                                <Collapse
                                  isOpen={
                                    this.state.collapsemenu &&
                                    text === this.state.textItem
                                  }
                                >
                                  <Card>
                                    <CardBody>
                                      <ul
                                        className={direction ? "mr-4" : "ml-4"}
                                      >
                                        {text.childrens.map((child, ind) => (
                                          <li>
                                            <Link
                                              style={{ color: "#fff" }}
                                              to={{
                                                pathname: child.url,
                                                state: child.state,
                                              }}
                                            >
                                              {" "}
                                              {child.name}{" "}
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </CardBody>
                                  </Card>
                                </Collapse>
                              </Col>
                            ) : (
                              <Col
                                lg="12"
                                className="pb-2"
                                style={{
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "6px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <Link
                                  id={this.state.flag ? "" : "centerIcons"}
                                  to={{ pathname: text.url }}
                                >
                                  <i
                                    style={{
                                      color: "#fffffe",
                                      paddingRight: "4px",
                                      display:
                                        this.state.smallScreen &&
                                        !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                    }}
                                    className={text.icon}
                                  ></i>

                                  <span
                                    style={{
                                      display: !this.state.flag
                                        ? "none"
                                        : "inline-block",
                                      fontSize: "14px",
                                      color: "#ffffffcc",
                                    }}
                                    onClick={() => {
                                      this.setState(
                                        { collapsemenu: false },
                                        () => {
                                          this.setTextitem(text);
                                        }
                                      );
                                    }}
                                  >
                                    {text.name}
                                  </span>
                                  {/* {text.badge === true && text.badgeData.length > 0 ?
                                                                text.badgeData.map((ele, index) => {
                                                                    return (
                                                                        <span>
                                                                            <Badge id={text.target} className="mx-1 p-1" style={{ fontSize: '13px!important' }} color={this.getbadgeColor()}>{ele}</Badge>
                                                                        </span>
                                                                    )
                                                                })
    
                                                                : null} */}
                                </Link>
                              </Col>
                            )
                          ) : text.childrens ? (
                            text.roleNumber ? (
                              this.getroleNumber(text.roleNumber) && (
                                <Col
                                  lg="12"
                                  className="headerBorder headerBorderen pb-2"
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.textItem === text &&
                                      this.state.toggle
                                        ? "rgba(30, 30, 30,.6)"
                                        : "",
                                    display: "block",
                                    marginBottom: this.state.flag
                                      ? ""
                                      : "1.5rem",
                                    paddingRight: "15px",
                                    paddingLeft: "6px",
                                  }}
                                >
                                  <h5
                                    id={this.state.flag ? "" : "centerIcons"}
                                    onClick={() => {
                                      this.toggle();
                                      this.togglemenu();
                                      this.setTextitem(text);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    {/* <Row> */}
                                    <div lg="9" md="9" sm="11" xs="11">
                                      <i
                                        style={{
                                          color: "#fffe",
                                          paddingRight: "4px",
                                          display:
                                            this.state.smallScreen &&
                                            !this.state.flag
                                              ? "none"
                                              : "inline-block",
                                        }}
                                        className={text.icon}
                                      ></i>
                                      <span
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                          fontSize: "14px",
                                          color: "#ffffffcc",
                                        }}
                                      >
                                        {text.name}
                                      </span>
                                    </div>
                                    <div
                                      className="fixWidthIcon"
                                      lg="2"
                                      md="2"
                                      sm="1"
                                      xs="1"
                                    >
                                      <i
                                        style={{
                                          display: !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                        }}
                                        className={
                                          this.state.textItem === text &&
                                          this.state.toggle
                                            ? "fa fa-chevron-up"
                                            : "fa fa-chevron-down"
                                        }
                                      ></i>
                                    </div>
                                    {/* </Row> */}
                                  </h5>
                                  <Collapse
                                    isOpen={
                                      this.state.collapsemenu &&
                                      text === this.state.textItem
                                    }
                                  >
                                    <Card>
                                      <CardBody>
                                        <ul
                                          className={
                                            direction ? "mr-4" : "ml-4"
                                          }
                                        >
                                          {text.childrens.map((child, ind) =>
                                            this.getroleNumber(
                                              child.roleNumber
                                            ) ? (
                                              <li>
                                                <Link
                                                  style={{ color: "#fff" }}
                                                  to={{
                                                    pathname: child.url,
                                                    state: child.state,
                                                  }}
                                                >
                                                  {" "}
                                                  {child.name}{" "}
                                                </Link>
                                              </li>
                                            ) : null
                                          )}
                                        </ul>
                                      </CardBody>
                                    </Card>
                                  </Collapse>
                                </Col>
                              )
                            ) : this.IsArrayHasRole(text.childrens) ? (
                              <Col
                                lg="12"
                                className="headerBorder headerBorderen pb-2"
                                key={index}
                                style={{
                                  backgroundColor:
                                    this.state.textItem === text &&
                                    this.state.toggle
                                      ? "rgba(30, 30, 30,.6)"
                                      : "",
                                  display: "block",
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "15px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <h5
                                  id={this.state.flag ? "" : "centerIcons"}
                                  onClick={() => {
                                    this.toggle();
                                    this.togglemenu();
                                    this.setTextitem(text);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {/* <Row> */}
                                  <div lg="9" md="9" sm="11" xs="11">
                                    <i
                                      style={{
                                        color: "#fffe",
                                        paddingRight: "4px",
                                        display:
                                          this.state.smallScreen &&
                                          !this.state.flag
                                            ? "none"
                                            : "inline-block",
                                      }}
                                      className={text.icon}
                                    ></i>
                                    <span
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                        fontSize: "14px",
                                        color: "#ffffffcc",
                                      }}
                                    >
                                      {text.name}
                                    </span>
                                  </div>
                                  <div
                                    className="fixWidthIcon"
                                    lg="2"
                                    md="2"
                                    sm="1"
                                    xs="1"
                                  >
                                    <i
                                      style={{
                                        display: !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                      }}
                                      className={
                                        this.state.textItem === text &&
                                        this.state.toggle
                                          ? "fa fa-chevron-up"
                                          : "fa fa-chevron-down"
                                      }
                                    ></i>
                                  </div>
                                  {/* </Row> */}
                                </h5>
                                <Collapse
                                  isOpen={
                                    this.state.collapsemenu &&
                                    text === this.state.textItem
                                  }
                                >
                                  <Card>
                                    <CardBody>
                                      <ul
                                        className={direction ? "mr-4" : "ml-4"}
                                      >
                                        {text.childrens.map(
                                          (child, ind) =>
                                            this.getroleNumber(
                                              child.roleNumber
                                            ) && (
                                              <li>
                                                <Link
                                                  style={{ color: "#fff" }}
                                                  to={{
                                                    pathname: child.url,
                                                    state: child.state,
                                                  }}
                                                >
                                                  {" "}
                                                  {child.name}{" "}
                                                </Link>
                                              </li>
                                            )
                                        )}
                                      </ul>
                                    </CardBody>
                                  </Card>
                                </Collapse>
                              </Col>
                            ) : null
                          ) : (
                            this.getroleNumber(text.roleNumber) && (
                              <Col
                                lg="12"
                                className="pb-2"
                                style={{
                                  marginBottom: this.state.flag ? "" : "1.5rem",
                                  paddingRight: "6px",
                                  paddingLeft: "6px",
                                }}
                              >
                                <Link
                                  id={this.state.flag ? "" : "centerIcons"}
                                  to={{ pathname: text.url }}
                                >
                                  <i
                                    style={{
                                      color: "#fffffe",
                                      paddingRight: "4px",
                                      display:
                                        this.state.smallScreen &&
                                        !this.state.flag
                                          ? "none"
                                          : "inline-block",
                                    }}
                                    className={text.icon}
                                  ></i>

                                  <span
                                    style={{
                                      display: !this.state.flag
                                        ? "none"
                                        : "inline-block",
                                      fontSize: "14px",
                                      color: "#ffffffcc",
                                    }}
                                    onClick={() => {
                                      this.setState(
                                        { collapsemenu: false },
                                        () => {
                                          this.setTextitem(text);
                                        }
                                      );
                                    }}
                                  >
                                    {text.name}
                                  </span>
                                  {/* {text.badge === true && text.badgeData.length > 0 ?
                                                                text.badgeData.map((ele, index) => {
                                                                    return (
                                                                        <span>
                                                                            <Badge id={text.target} className="mx-1 p-1" style={{ fontSize: '13px!important' }} color={this.getbadgeColor()}>{ele}</Badge>
                                                                        </span>
                                                                    )
                                                                })
    
                                                                : null} */}
                                </Link>
                              </Col>
                            )
                          );
                        })}
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.userInfo.language,
    token: state.userInfo.token,
    sideMenu: state.setting.sideMenu,
    type: state.userInfo.Type,
    user: state.userInfo.user,
  };
};

export default connect(mapStateToProps, null)(SideMenu);
